import { FC } from 'react';
import { CSVHeaderRowRadio } from './CSVHeaderRowRadio';
import { DEFAULT_HEADER, ITEM_HEADER } from '../createDataSource/createDataSourceContent/dataSourceTypes/file/constants';

type CSVRowIsHeaderOrItemProps = {
  csvHeader: string;
  onTypeChange: (value: string) => void;
};

export const CSVRowIsHeaderOrItem: FC<CSVRowIsHeaderOrItemProps> = ({ csvHeader, onTypeChange }) => {
  return (
    <div className='flex flex-col gap-2'>
      <CSVHeaderRowRadio
        labelKey='data_source_edit.file.header.is_the_header'
        labelFor='is-header'
        value={DEFAULT_HEADER}
        checked={csvHeader === DEFAULT_HEADER}
        onChange={() => onTypeChange(DEFAULT_HEADER)}
      />
      <CSVHeaderRowRadio
        labelKey='data_source_edit.file.header.is_an_item'
        labelFor='is-not-header'
        value={ITEM_HEADER}
        checked={csvHeader === ITEM_HEADER}
        onChange={() => onTypeChange(ITEM_HEADER)}
      />
    </div>
  );
};
